import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import UnderConstruction from './Components/UnderConstruction/UnderConstruction';
import Login from './Components/Login/Login';
import RegisterPassword from './Components/RegisterPassword/RegisterPassword';
import TermsOfService from './Components/TermsOfService/TermsOfService';
import 'bootstrap-icons/font/bootstrap-icons.css';
import MainMenu from './Components/MainMenu/MainMenu';

function App() {
  return (
    <div className="App">
      <main>
        <BrowserRouter>
          <Routes>
            {/* 1. Rota Raiz */}
            <Route path="/" element={<UnderConstruction />} />

            {/* 2. Rota de Login */}
            <Route path="/login" element={<Login />} />

            {/* 2b. Rota pós-Login */}
            <Route path="/dashboard" element={<MainMenu />} />

            {/* 3. Rota de Cadastro de Senha */}
            <Route path="/cadastrar-senha" element={<RegisterPassword />} />

            {/* 4. Rota de Termos de Uso (Componente Reestilizado) */}
            <Route path="/termos-de-uso" element={<TermsOfService />} />

            {/* 5. Rota 404 - Captura qualquer caminho não definido acima */}
            <Route path="*" element={
              <div className="container text-center py-5">
                <h1 className="display-1 fw-bold text-muted">404</h1>
                <h3 className="mb-4">Ops! A página que você está procurando não existe.</h3>
                <p>Clique em <strong>VOLTAR</strong> no seu navegador ou use os links do site.</p>
              </div>
            } />
          </Routes>
        </BrowserRouter>
      </main>
    </div>
  );
}

export default App;